import React from "react";
import TodoListTask from "components/TodoList/TimelineTodoTasks/TodoListTask/TodoListTask";

export default ({ listTasks, total }) => {
  const noList = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  return (
    <div className="mt-30">
      {listTasks.map((listTask, index) => (
        <TodoListTask key={listTask.id} listTask={listTask} index={index} />
      ))}
      {total === 0 && <div style={noList}>You don't have any tasks</div>}
    </div>
  );
};
